import { render, staticRenderFns } from "./twitter-icon.vue?vue&type=template&id=447bc5a1&functional=true&"
import script from "./twitter-icon.vue?vue&type=script&lang=js&"
export * from "./twitter-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports